import { CommonAction } from "../../../login/redux/types";
import DealPaymentTypes, { Payment } from "./types";

function getDealPaymentReq(uuid: string) :CommonAction {
    return {
        type: DealPaymentTypes.DEAL_REPAYMENT_REQ,
        payload: uuid
    }
}

function setDealPaymentReq(dealPayment: Payment | undefined): CommonAction {
    return {
        type: DealPaymentTypes.SET_DEAL_REPAYMENT_REQ,
        payload: dealPayment
    }
}

const DealPaymentActions = {
    getDealPaymentReq,
    setDealPaymentReq
}

export default DealPaymentActions;